<template>
  <div am-activity-bd>
    Activity
    <div
      v-if="store.state.activity.loading"
      class="_margin-top:1/4 _align-self:stretch _display:flex _justify-content:center _align-items:center _height:100%"
    >
      <ILoader color="primary" size="sm" />
    </div>
    <div
      v-else-if="store.state.activity.error"
      class="_display:flex _justify-content:center _align-items:center _flex-direction:column"
    >
      <p>Something went wrong, activity didn't load</p>
      <IButton
        size="sm"
        color="primary"
        @click="store.dispatch('activity/getActivity', `part_id=${id}`)"
      >
        Reload
      </IButton>
    </div>
    <div v-else-if="!store.state.activity.data?.length">
      <p class="_font-size:sm">no activities</p>
    </div>
    <template v-else>
      <div
        v-for="activity in store.state.activity.data"
        :key="activity"
        class="_margin-top:1 _margin-bottom:1"
      >
        <ICard size="sm">
          <template #header>
            <p class="_font-size:sm">
              <span class="_font-weight:bold">
                {{ activity.user.name === store.state.user.userInfo.name ? 'You' : activity.user.name }}
              </span> edited this record
            </p>
            <p class="_font-size:sm">{{ dateConvert(activity.updated_at) }}</p>
          </template>
          <div v-for="diff in activity.diff" :key="diff">
            <p class="_font-weight:bold _margin:0">{{ getFieldDiff(diff[0])?.name }}</p>
            <div v-if="diff[0] === 'image'">
              <div @click="downloadSVG(diff[1])" v-html="diff[1]" class="_margin:1 _border _background:light-60 _border-color:danger" />
              <div @click="downloadSVG(diff[1])" v-html="diff[2]" class="_margin:1 _border _border-color:success _background:light-60" />
            </div>
            <div v-else-if="getFieldDiff(diff[0])?.category === 'field'">
              <div am-diff-text>
                <span
                  v-for="item in dmp.diff_main(diff[1].toString(), diff[2].toString())"
                  :key="item"
                  :am-text="item[0]"
                >
                  {{item[1]}}
                </span>
              </div>
            </div>
            <div v-else-if="getFieldDiff(diff[0])?.category === 'fieldsArray'">
              <div
                v-for="arr in diff[1]"
                :key="arr"
              >
                <p v-if="!diff[2]?.includes(arr)" line-through class="_margin:0">
                  {{ arr }}
                </p>
              </div>
              <div
                v-for="arr in diff[2]"
                :key="arr"
              >
                <p v-if="!diff[1]?.includes(arr)" class="_margin:0">
                  {{ arr }}
                </p>
              </div>
            </div>

            <div v-else-if="getFieldDiff(diff[0])?.category === 'paramssArray'">
              <div
                v-for="(value, key) in diff[1]"
                :key="key"
              >
                <i-badge
                  color="danger"
                  v-if="diff[2]?.[key] !== value.join()"
                  am-param-badge
                  class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                >
                  <p class="_margin:0" line-through>
                    {{ Number(key) ?  `par ${key}` : `${key}`}} = {{ value.join() }}
                  </p>
                </i-badge>
              </div>
              <div
                v-for="(value, key) in diff[2]"
                :key="key"
              >
                <i-badge
                  v-if="diff[1]?.[key] !== value.join()"
                  color="success"
                  am-param-badge
                  class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                >
                  <p class="_margin:0">
                    {{ Number(key) ?  `par ${key}` : `${key}`}} = {{ value.join() }}
                  </p>
                </i-badge>
              </div>
            </div>
            <div v-else-if="getFieldDiff(diff[0])?.category === 'params'">
              <div
                v-for="(value, key) in diff[1]"
                :key="key"
              >
                <i-badge
                  color="danger"
                  v-if="diff[2]?.[key] !== value"
                  am-param-badge
                  class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                >
                  <p class="_margin:0">
                    {{ Number(key) ?  `par ${key}` : `${key}`}} = {{ value }}
                  </p>
                </i-badge>
              </div>
              <div
                v-for="(value, key) in diff[2]"
                :key="key"
              >
                <i-badge
                  v-if="diff[1]?.[key] !== value"
                  color="success"
                  am-param-badge
                  class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                >
                  <p class="_margin:0">
                    {{ Number(key) ?  `par ${key}` : `${key}`}} = {{ value }}
                  </p>
                </i-badge>
              </div>
            </div>
            <div v-else-if="getFieldDiff(diff[0])?.category === 'allowedparams'">
              <div
                v-for="(value, key) in diff[1]"
                :key="value.name"
                class="_margin-right:1"
              >
                <p class="_margin:0">
                  {{ value.display_name }}
                </p>
                <i-checkbox-group
                  v-model="diff[2][key]"
                >
                  <i-checkbox
                    v-for="(facing, index) in value.possible"
                    :key="index"
                    :value="index"
                    class="_margin-y:1/2 _border-color:light"
                    size="sm"
                  >
                    <p
                      v-if="diff[1][key].selected.includes(index) && !diff[2][key].includes(index)"
                      class="_margin:0 _color:danger"
                      line-through
                    >
                      {{ index }} ({{ facing }})
                    </p>
                    <p
                      v-else-if="!diff[1][key].selected.includes(index) && diff[2][key].includes(index)"
                      class="_margin:0 _color:success"
                    >
                      {{ index }} ({{ facing }})
                    </p>
                    <p
                      v-else
                      class="_margin:0"
                    >
                      {{ index }} ({{ facing }})
                    </p>
                  </i-checkbox>
                </i-checkbox-group>
              </div>
            </div>
            <div v-else-if="diff[0] === 'attributes'">
              <div v-for="(attrs, type) in diff[3]" :key="type">
                <p class="_font-weight:bold _margin:0">{{getFieldDiff(type).name}}</p>
                <i-badge
                  color="primary"
                  v-for="(attr, index) in attrs"
                  :key="index"
                  :am-tag-badge="attr.id % 10"
                  :class="`_border _border-color:${attr.isNew ? 'success' : 'danger'} _margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between`"
                  :title="attr.name"
                >
                  <p :line-through="attr.isOld">{{ attr.name }}</p>
                </i-badge>
              </div>
            </div>
            <div v-else-if="diff[0] === 'image_ids' || diff[0] === 'delete_image_ids'">
              <div v-for="(imgs, type) in diff[3]" :key="type">
                <p class="_font-weight:bold _margin:0">{{getFieldDiff(type).name}}</p>
                <div
                  v-for="(img, index) in imgs"
                  :key="index"
                  v-html="img.image"
                  :class="`_margin:1 _border _border-color:${diff[0] === 'image_ids' ? 'success' : 'danger'} _background:light-60`"
                />
              </div>
            </div>
            <div v-else>
            {{diff}}
            </div>
          </div>
        </ICard>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useStore } from 'vuex'
import DiffMatchPatch from 'diff-match-patch'
const dmp = new DiffMatchPatch()
const store = useStore()
const prop = defineProps(['val'])
const id = computed(() => {
  if (prop.val) {
    return prop.val.find(el => el.name === 'id').data
  } else return null
})
const dateConvert = (publicationDate) => {
  const date = new Date(publicationDate)
  return date.toLocaleString('en', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}
const getFieldDiff = (name) => {
  return prop.val.find(el => el.type === name)
}

const downloadSVG = (svgString) => {
  const blob = new Blob([svgString], { type: 'image/svg+xmlcharset=utf-8' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = 'image.svg'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
</script>

<style lang="scss">
[am-activity-bd] {
  [line-through] {
    text-decoration: line-through;
  }
  [am-diff-text] {
    [am-text~='-1'] {
      background-color: var(--color--danger);
      text-decoration: line-through;
    }
    [am-text~='1'] {
      background-color: var(--color--success);
    }
  }
}
</style>
